import React, { useEffect, useMemo } from "react"
import _, { merge } from "lodash"

interface props {
  id: string
  position?: object
  priority?: number
  parentElementId?: string
  targetWidth?: number
  targetHeight?: number
}

class MaxRect {
  max_left: number
  max_right: number
  max_top: number
  max_bottom: number
  constructor() {
    this.max_left = 0
    this.max_right = 0
    this.max_top = 0
    this.max_bottom = 0
  }
  setData = (l: number, r: number, t: number, b: number) => {
    this.max_left = l
    this.max_right = r
    this.max_top = t
    this.max_bottom = b
  }
}
const maxRect = new MaxRect()

const useDraggableDialog = (props: props) => {
  const { id } = props

  // 親要素がある場合、親のtop, left, right, bottomを取得し、移動範囲を設定する。
  const parentElement = props.parentElementId
    ? document.getElementById(props.parentElementId)
    : null
  const rect = parentElement && parentElement.getBoundingClientRect()
  const max_left = _.get(rect, "left", 0)
  const max_right = _.get(rect, "right", window.innerWidth)
  const max_top = _.get(rect, "top", 0)
  const max_bottom = _.get(rect, "bottom", window.innerHeight)
  const width = _.get(props, "targetWidth", 0)
  const height = _.get(props, "targetHeight", 0)

  useEffect(() => {
    maxRect.setData(max_left, max_right - width, max_top, max_bottom - height)
  }, [max_left, max_right, max_top, max_bottom, width, height])

  const _position = useMemo(() => {
    let def = props.position || {
      left: 0,
      top: 0,
    }
    if (props.parentElementId) _.merge(def, { left: max_left, top: max_top })
    return def
  }, [max_left, max_top])

  const _priority = useMemo(() => {
    return props.priority || 0
  }, [])

  const moveModal = () => {
    // mouseDown event
    const mdown = (e: any) => {
      let event
      if (e.type === "mousedown") {
        event = e
      } else {
        event = e.changedTouches[0]
      }

      //要素内の相対座標を取得
      x = event.pageX - element.offsetLeft
      y = event.pageY - element.offsetTop

      //ムーブイベントにコールバック
      document.body.addEventListener("mousemove", mmove, false)
      document.body.addEventListener("touchmove", mmove, false)
    }
    // mouseMove event
    const mmove = (e: any) => {
      //同様にマウスとタッチの差異を吸収
      let event: any
      if (e.type === "mousemove") {
        event = e
      } else {
        event = e.changedTouches[0]
      }

      //フリックしたときに画面を動かさないようにデフォルト動作を抑制
      e.preventDefault()
      //マウスが動いた場所に要素を動かす
      if (element.style.right) element.style.removeProperty("right")
      let _top = event.pageY - y
      let _left = event.pageX - x
      // 親要素の指定がある場合、親の範囲を飛び出さないようにする。
      if (props.parentElementId) {
        if (_top <= maxRect.max_top) _top = maxRect.max_top
        if (_top >= maxRect.max_bottom) _top = maxRect.max_bottom
        if (_left <= maxRect.max_left) _left = maxRect.max_left
        if (_left >= maxRect.max_right) _left = maxRect.max_right
      }
      element.style.top = _top + "px"
      element.style.left = _left + "px"
      // element.addEventListener("mouseup", mup, false)
      // document.body.addEventListener("mouseleave", mup, false)
      // element.addEventListener("touchend", mup, false)
      // document.body.addEventListener("touchleave", mup, false)
    }
    // mouseUp & mouseLeave event
    const mup = (e: any) => {
      //ムーブベントハンドラの消去
      document.body.removeEventListener("mousemove", mmove, false)
      // drag.removeEventListener("mouseup", mup, false)
      document.body.removeEventListener("touchmove", mmove, false)
      // drag.removeEventListener("touchend", mup, false)
    }

    let x = 0
    let y = 0
    const element = document.getElementById(id) as HTMLElement
    if (!element) return
    element.addEventListener("mousedown", mdown, false)
    element.addEventListener("touchstart", mdown, false)
    //マウスボタンが離されたとき、またはカーソルが外れたとき発火
    element.addEventListener("mouseup", mup, false)
    document.body.addEventListener("mouseleave", mup, false)
    element.addEventListener("touchend", mup, false)
    document.body.addEventListener("touchleave", mup, false)
  }
  useEffect(() => {
    moveModal()
  }, [])

  return _.merge(
    {
      position: "fixed" as any,
      zIndex: 100 + _priority,
    },
    _position
  )
}

export default useDraggableDialog
